// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  // Load translation using http -> see /public/locales
  // (i.e. we’ll place JSON translation files in public/locales)
  .use(HttpApi)
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({ // Init i18next
    supportedLngs: ['en', 'zh', 'jp'], // List of languages you support
    fallbackLng: 'en',                 // Default language if detection fails
    //debug: true,                      // Set true only during dev

    detection: {
      // The order in which the detector will look for the user’s language
      order: ['localStorage', 'cookie', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Where to store the language
      caches: ['localStorage'],
      // optional expire and domain for set cookie
      // cookieMinutes: 10080, // 7 days
      // cookieDomain: 'myDomain',
    },

    backend: { // Options for i18next-http-backend
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path where resources get loaded from
      //loadPath: `${window.location.origin}/locales/{{lng}}/{{ns}}.json`,
    },
    
    // Default namespace used if not passed to translation function
    ns: [
      'Login', 
      'SidebarContent',
      'common'
    ],

    defaultNS: 'common',

    // React i18next special options
    react: {
      //useSuspense: true,
      useSuspense: false,
    },

    load: 'all', // This ensures all namespaces are loaded
    keySeparator: false,
  });

export default i18n;






